import { ICategoryPublicationResponse } from "../../../../model/sdp/official-daily/response/category-publication-response";
import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import { Box, FormControl, FormHelperText, MenuItem, Select, Tab, Tabs, TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { ISubCategoryPublicationResponse } from "../../../../model/sdp/official-daily/response/subcategory-publication-response";
import { IPreviewPublicationRequest } from "../../../../model/sdp/official-daily/request/preview-publication-request";
import { IEntityPublicationResponse } from "../../../../model/sdp/official-daily/response/entity-publication-response";
import DefaultUploadFiles from "../../../../components/default-upload-files";
import OfficialDiaryAppService from "../../../../application/platform/sdp/official-diary/official-diary-app-service";
import BaseAppService from "../../../../application/platform/sdp/base/base-app-service";
import DefaultSelectClient from "../../../../components/default-select-client";
import { IListDocumentTypesResponse } from "../../../../model/sdp/base/list-document-types-response";
import SubmissionPublicationAppService from "../../../../application/platform/sep/subimission-publication/subimission-publication-app-service";
import { useBaseLayout } from "../../../../components/context/use-base-layout";

export interface IPreviewPublicationProps {
    previewPublicationRequest: IPreviewPublicationRequest,
    setPreviewPublicationRequest: (params: IPreviewPublicationRequest) => void
    setFilesUpload: (file: File[]) => void,
    files: File[]
};
export default function FormPreviewPublication({ props }: { props: IPreviewPublicationProps }) {
    const { showLoading } = useBaseLayout();
    const [categories, setCategories] = useState<ICategoryPublicationResponse[]>([]);
    const [entityPublicattion, setEntityPublicattion] = useState<IEntityPublicationResponse[]>([]);
    const [subCategories, setSubCategories] = useState<ISubCategoryPublicationResponse[]>([]);
    const [documentTypes, setDocumentTypes] = useState<IListDocumentTypesResponse[]>([]);
    const [previewPublicationRequest, setPreviewPublicationRequest] = useState<IPreviewPublicationRequest>(props.previewPublicationRequest);
    const [tabIndex, setTabIndex] = useState(0);

    useEffect(() => {
        loadData();

        if (props.previewPublicationRequest !== undefined && props.previewPublicationRequest.categoryId !== 0) {
            loadSubcategory(props.previewPublicationRequest.categoryId);
        }


    }, []);


    useEffect(() => {


        (async () => {
            if (props.previewPublicationRequest.submissionPublicationId !== undefined) {
                let data = await SubmissionPublicationAppService.getById(props.previewPublicationRequest.submissionPublicationId);
                setPreviewPublicationRequest({ ...props.previewPublicationRequest, clientId: data.clientId });
            } else {
                setPreviewPublicationRequest(props.previewPublicationRequest);
            }



        })();

    }, [props.previewPublicationRequest]);

    const handleOnChange = (e: any) => {

        let categoryId = previewPublicationRequest.categoryId;
        let subcategoryId = previewPublicationRequest.subcategoryId;
        let number = previewPublicationRequest.number;
        let descriptionCommission = previewPublicationRequest.descriptionCommission;
        let descriptionPresidentCommission = previewPublicationRequest.descriptionPresidentCommission;
        let description = previewPublicationRequest.description;
        let notes = previewPublicationRequest.notes;
        let sanctionDateOn = previewPublicationRequest.sanctionDateOn;
        let entityPublicationId = previewPublicationRequest.publicAgencyId;
        let documentTypeId = previewPublicationRequest.documentTypeId;
        let clientId = previewPublicationRequest.clientId;
        let republication = previewPublicationRequest.republication;
        if (e.target.name === "select-category") {
            loadSubcategory(e.target.value);
            categoryId = e.target.value;
            number = "";
            if (e.target.value === 3) {
                descriptionCommission = "Comissão Permanente de Licitação";
            } else {
                descriptionCommission = "";
                sanctionDateOn = undefined;
                descriptionPresidentCommission = "";
            }
        } else if (e.target.name === "select-subcategory") {
            subcategoryId = e.target.value;
        } else if (e.target.name === "input-number") {
            number = e.target.value;
        } else if (e.target.name === "input-description-comission") {
            descriptionCommission = e.target.value;
        } else if (e.target.name === "input-description-president-comission") {
            descriptionPresidentCommission = e.target.value;
        } else if (e.target.name === "input-description") {
            description = e.target.value;
        } else if (e.target.name === "input-notes") {
            notes = e.target.value;
        } else if (e.target.name === "select-entity-publication") {
            entityPublicationId = e.target.value;
        } else if (e.target.name === "select-client") {
            clientId = e.target.value;
        } else if (e.target.name === "select-dcoument-type") {
            documentTypeId = e.target.value;
        }
        else if (e.target.name === "switch-repubblication") {
            republication = e.target.checked;
        }


        setPreviewPublicationRequest(prevState => {
            return { ...prevState, description, clientId, documentTypeId, categoryId, number, subcategoryId, descriptionPresidentCommission, descriptionCommission, sanctionDateOn, notes, publicAgencyId: entityPublicationId, republication };
        });
        props.setPreviewPublicationRequest(previewPublicationRequest);
    }

    const loadSubcategory = (id: number) => {
        (async () => {
            showLoading({ open: true });
            const data = await OfficialDiaryAppService.listSubcategories(id);
            setSubCategories(data);
            showLoading({ open: false });
        })();
    }

    const loadData = () => {
        (async () => {
            showLoading({ open: true });
            const data1 = await OfficialDiaryAppService.listCategories();
            setCategories(data1);
            const data2 = await OfficialDiaryAppService.listEntityPublication();
            setEntityPublicattion(data2);
            const data3 = await BaseAppService.listDocumentTypes();
            setDocumentTypes(data3);
            showLoading({ open: false });
        })();
    }



    const handleTabChange = (event: any, newTabIndex: number) => {
        setTabIndex(newTabIndex);
    };

    return (<React.Fragment>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={2}>
                <Grid item lg={8}
                    sm={8}
                    xl={8}>
                    <DefaultSelectClient required={true} clientId={previewPublicationRequest.clientId} disabled={previewPublicationRequest.submissionPublicationId !== undefined ? true : false} handleOnChange={handleOnChange}></DefaultSelectClient>

                </Grid>
                <Grid
                    item
                    lg={2}
                    sm={2}
                    xl={2}
                >
                    <InputLabel>Data da Publicação</InputLabel>
                    <DesktopDatePicker
                        inputFormat="DD/MM/YYYY" maxDate={moment()} minDate={moment()}
                        renderInput={(params) => <TextField {...params} fullWidth
                            error={previewPublicationRequest.publicationDateOn === undefined ? true : false}

                        />}
                        value={previewPublicationRequest.publicationDateOn !== undefined ? moment(previewPublicationRequest.publicationDateOn) : null}
                        onChange={(newValue) => {
                            let newDate = newValue as moment.Moment;
                            let publicationDateOn = newDate.format("YYYY-MM-DD");
                            let newObject = Object.assign(previewPublicationRequest, publicationDateOn);
                            props.setPreviewPublicationRequest(newObject);
                            setPreviewPublicationRequest(prevState => {
                                return { ...prevState, publicationDateOn };
                            });
                        }} />

                </Grid>
                <Grid
                    item
                    lg={2}
                    sm={2}
                    xl={2}
                    sx={{
                        display: "flex", justifyContent: 'flex-end'
                    }}

                >
                    <FormControlLabel control={<Switch checked={previewPublicationRequest.republication} name="switch-repubblication" onChange={handleOnChange} />} label="Republicação" />

                </Grid>

                <Grid item lg={6}
                    sm={6}
                    xl={6}>
                    <InputLabel>Categoria</InputLabel>
                    <Select
                        onChange={handleOnChange}
                        fullWidth
                        error={previewPublicationRequest.categoryId === undefined ? true : false}
                        name='select-category'
                        value={previewPublicationRequest.categoryId}
                    >
                        <MenuItem value={undefined}>
                            <em>Selecionar</em>
                        </MenuItem>
                        {categories.map((element, index) => {
                            return (
                                <MenuItem value={element.id} key={element.id}>{element.description}</MenuItem>
                            );
                        })}

                    </Select>
                </Grid>
                <Grid item lg={6}
                    sm={6}
                    xl={6}>
                    <InputLabel>Subcategoria</InputLabel>
                    <Select
                        name='select-subcategory'
                        onChange={handleOnChange}
                        fullWidth
                        error={previewPublicationRequest.subcategoryId === undefined ? true : false}
                        value={previewPublicationRequest.subcategoryId}
                    >
                        <MenuItem value={undefined}>
                            <em>Selecionar</em>
                        </MenuItem>
                        {subCategories.map((element, index) => {
                            return (
                                <MenuItem value={element.id} key={element.id}>{element.description}</MenuItem>
                            );
                        })}

                    </Select>
                </Grid>
                <Grid item lg={6}
                    sm={6}
                    xl={6}>
                    <InputLabel>Orgão de Publicação</InputLabel>
                    <Select
                        name='select-entity-publication'
                        onChange={handleOnChange}
                        fullWidth
                        error={previewPublicationRequest.publicAgencyId === undefined ? true : false}
                        value={previewPublicationRequest.publicAgencyId}
                    >
                        <MenuItem value={undefined}>
                            <em>Selecionar</em>
                        </MenuItem>
                        {entityPublicattion.map((element, index) => {
                            return (
                                <MenuItem value={element.id} key={element.id}>{element.description}</MenuItem>
                            );
                        })}

                    </Select>
                </Grid>

                <Grid item lg={6}
                    sm={6}
                    xl={6}>
                    <InputLabel>Tipo de Documento</InputLabel>
                    <Select
                        name='select-dcoument-type'
                        onChange={handleOnChange}
                        fullWidth
                        error={previewPublicationRequest.documentTypeId === undefined ? true : false}
                        value={previewPublicationRequest.documentTypeId}
                    >
                        <MenuItem value={undefined}>
                            <em>Selecionar</em>
                        </MenuItem>
                        {documentTypes.map((element, index) => {
                            return (
                                <MenuItem value={element.id} key={element.id}>{element.description}</MenuItem>
                            );
                        })}

                    </Select>
                </Grid>


                <Grid item xs={1} md={1} lg={1}>
                    <InputLabel>{previewPublicationRequest.categoryId === 2 ? 'Ano Base' : 'Número'}</InputLabel>
                    <OutlinedInput

                        value={previewPublicationRequest?.number}
                        name="input-number"
                        onChange={handleOnChange}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={4} md={4} lg={4}>
                    <InputLabel>Comissão de Licitação</InputLabel>
                    <OutlinedInput
                        disabled={previewPublicationRequest.categoryId !== 3 ? true : false}
                        value={previewPublicationRequest?.descriptionCommission}
                        name="input-description-comission"
                        fullWidth
                        onChange={handleOnChange}
                    />
                </Grid>
                <Grid item xs={5} md={5} lg={5}>
                    <InputLabel>Responsável da Comissão de Licitação</InputLabel>
                    <OutlinedInput
                        disabled={previewPublicationRequest.categoryId !== 3 ? true : false}
                        value={previewPublicationRequest?.descriptionPresidentCommission}
                        name="input-description-president-comission"
                        fullWidth
                        onChange={handleOnChange}
                    />
                </Grid>

                <Grid
                    item
                    lg={2}
                    sm={2}
                    xl={2}
                >
                    <InputLabel>{previewPublicationRequest.categoryId !== 3 ? 'Data de Sanção' : 'Data de Abertura'}</InputLabel>
                    <DesktopDatePicker

                        disabled={previewPublicationRequest.categoryId !== 3 ? true : false}
                        inputFormat="DD/MM/YYYY" maxDate={moment()}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                        value={previewPublicationRequest.sanctionDateOn !== undefined ? moment(previewPublicationRequest.sanctionDateOn) : null}
                        onChange={(newValue) => {
                            let newDate = newValue as moment.Moment;
                            if (newDate !== undefined) {
                                let sanctionDateOn = newDate.format("YYYY-MM-DD");
                                let newObject = Object.assign(previewPublicationRequest, sanctionDateOn);
                                props.setPreviewPublicationRequest(newObject);
                                setPreviewPublicationRequest(prevState => {
                                    return { ...prevState, sanctionDateOn };
                                });
                            } else {
                                let sanctionDateOn = undefined;
                                let newObject = Object.assign(previewPublicationRequest, sanctionDateOn);
                                props.setPreviewPublicationRequest(newObject);
                                setPreviewPublicationRequest(prevState => {
                                    return { ...prevState, sanctionDateOn: undefined };
                                });
                            }
                        }} />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <Box>
                        <Box>
                            <Tabs value={tabIndex} onChange={handleTabChange}>
                                <Tab label="Descrição" />
                                <Tab label="Observação" />
                            </Tabs>
                        </Box>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                        {tabIndex === 0 && (
                            <Box>
                                <OutlinedInput
                                    error={previewPublicationRequest.description === undefined || previewPublicationRequest.description.length === 0 ? true : false}
                                    multiline
                                    rows={5}
                                    onChange={handleOnChange}
                                    name="input-description"
                                    value={previewPublicationRequest?.description}
                                    fullWidth
                                />

                            </Box>
                        )}
                        {tabIndex === 1 && (
                            <Box>
                                <OutlinedInput
                                    multiline
                                    rows={5}
                                    onChange={handleOnChange}
                                    name="input-note"
                                    value={previewPublicationRequest?.notes}
                                    fullWidth
                                />

                            </Box>
                        )}
                    </Box>
                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <DefaultUploadFiles props={{ setFilesUpload: props.setFilesUpload, files: props.files }}></DefaultUploadFiles>
                </Grid>
            </Grid>
        </LocalizationProvider>
    </React.Fragment>)
};